(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3848],{

/***/ 65529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workstation",
      function () {
        return __webpack_require__(14381);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ AnimatePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(18716);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/AnimatePage.tsx



// interface AnimatePageProps {
// 	children: ReactNode;
// }
var AnimatePage = function(param) {
    var children = param.children;
    var variants = {
        hidden: {
            opacity: 0,
            x: 0,
            y: 100
        },
        enter: {
            opacity: 1,
            x: 0,
            y: 0
        },
        exit: {
            opacity: 0,
            x: 0,
            y: -100
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: "enter",
        exit: "exit",
        variants: variants,
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/index.ts



/***/ }),

/***/ 75198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/Container/Container.tsx

var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto w-full px-4 md:max-w-5xl",
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Container/index.ts



/***/ }),

/***/ 75111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ SeoHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(72167);
;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/SeoHead.tsx



var SeoHead = function(param) {
    var _title = param.title, title = _title === void 0 ? "Deepankar Sharma - Senior Software Engineer" : _title, description = param.description, _author = param.author, author = _author === void 0 ? "Deepankar Sharma" : _author, keywords = param.keywords, _image = param.image, image = _image === void 0 ? "https://www.deepankar.online/images/deepankar.online.png" : _image, _type = param.type, type = _type === void 0 ? "website" : _type, date = param.date, modifiedDate = param.modifiedDate, canonicalUrl = param.canonicalUrl, _meta = param.meta, meta = _meta === void 0 ? [] : _meta, article = param.article;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            (article === null || article === void 0 ? void 0 : article.modifiedTime) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "".concat(title, " | Deepankar's Blog | ").concat((0,format/* default */.Z)(new Date(article.modifiedTime), "MMM yyyy"))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "".concat(title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: author
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords.join(", ")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Deepankar Sharma's Blog"
            }),
            canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image:alt",
                content: "Cover image for ".concat(title)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:site",
                content: "https://x.com/geeky_lad"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: author
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            article && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: article.publishedTime
                    }),
                    article.modifiedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:modified_time",
                        content: article.modifiedTime
                    }),
                    article.section && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:section",
                        content: article.section
                    }),
                    (ref = article.tags) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "article:tag",
                            content: tag
                        }, tag);
                    })
                ]
            }),
            meta.map(function(param) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: name,
                    content: content
                }, name);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            canonicalUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "alternate",
                type: "application/rss+xml",
                title: "".concat(author, "'s Blog RSS Feed"),
                href: "/rss.xml"
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/index.ts



/***/ }),

/***/ 14381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99611);
/* harmony import */ var Atoms_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75198);
/* harmony import */ var utils_mdxComponents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85157);
/* harmony import */ var Atoms_AnimatePage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88678);
/* harmony import */ var Atoms_SeoHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75111);






var WorkstationPage = function(param) {
    var markdown = param.markdown;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Atoms_AnimatePage__WEBPACK_IMPORTED_MODULE_3__/* .AnimatePage */ .b, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Atoms_SeoHead__WEBPACK_IMPORTED_MODULE_4__/* .SeoHead */ .f, {
                title: "Workstation | Deepankar Sharma",
                description: "This is a comprehensive list of tech equipment and software I use for my day-to-day work as a software engineer."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Atoms_Container__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "headline text-3xl md:text-5xl lg:text-6xl mt-8",
                        children: "Workstation"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_5__/* .ReactMarkdown */ .D, {
                        components: utils_mdxComponents__WEBPACK_IMPORTED_MODULE_2__/* .mdxComponents */ .d,
                        children: markdown
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (WorkstationPage);


/***/ }),

/***/ 85157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ mdxComponents; }
/* harmony export */ });
/* unused harmony export blurDataURL */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26671);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54237);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82010);
/* harmony import */ var _sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84004);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13692);











var id_replacements = [
    [
        ".",
        ""
    ],
    [
        "'",
        ""
    ]
];
var mdxComponents = {
    h1: function(param) {
        var children = param.children;
        var id = (0,_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children === null || children === void 0 ? void 0 : children.toString(), {
            customReplacements: id_replacements
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
            id: id,
            className: "headline text-4xl mt-8",
            children: children
        });
    },
    h2: function(param) {
        var children = param.children;
        var id = (0,_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children === null || children === void 0 ? void 0 : children.toString(), {
            customReplacements: id_replacements
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            id: id,
            className: "headline text-3xl mt-6",
            children: children
        });
    },
    h3: function(param) {
        var children = param.children;
        var id = (0,_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children === null || children === void 0 ? void 0 : children.toString(), {
            customReplacements: id_replacements
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            id: id,
            className: "headline text-2xl mt-4",
            children: children
        });
    },
    h4: function(param) {
        var children = param.children;
        var id = (0,_sindresorhus_slugify__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(children === null || children === void 0 ? void 0 : children.toString(), {
            customReplacements: id_replacements
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
            id: id,
            className: "headline text-xl mt-4",
            children: children
        });
    },
    a: function(param) {
        var children = param.children, href = param.href;
        var isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            href: href
        }, isInternalLink ? {} // No need to add `target` or `rel` for internal links
         : {
            target: "_blank",
            rel: "noopener noreferrer"
        } // External links open in a new tab
        ), {
            className: "relative underlined text-yellow-600",
            children: children
        }));
    },
    ul: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "list-disc ml-4 my-2",
            children: children
        });
    },
    ol: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
            className: "list-decimal ml-4 my-2",
            children: children
        });
    },
    li: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "my-1",
            children: children
        });
    },
    hr: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
            className: "mt-6",
            children: children
        });
    },
    p: function(param) {
        var children = param.children;
        var ref, ref1;
        // return <p className="mt-4 mb-4 text-lg leading-7">{children}</p>
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var isImage = ((ref = children[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.type) === null || ref1 === void 0 ? void 0 : ref1.name) === "img";
        return isImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "my-2",
            children: children
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "my-3 text-lg leading-7",
            children: children
        });
    },
    code: function(_param) {
        var node = _param.node, inline = _param.inline, className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
            "node",
            "inline",
            "className",
            "children"
        ]);
        var language = (className === null || className === void 0 ? void 0 : className.replace("language-", "")) || "python";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomCodeHighlighter, {
            inline: inline,
            language: language,
            children: children
        });
    },
    img: function(param) {
        var alt = param.alt, src = param.src;
        /* eslint-disable */ var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(16 / 9), aspectRatio = ref[0], setAspectRatio = ref[1];
        var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
        var handleImageLoad = function(param) {
            var naturalWidth = param.naturalWidth, naturalHeight = param.naturalHeight;
            console.log("naturalDimensions", naturalWidth, naturalHeight);
            setAspectRatio(naturalWidth / naturalHeight);
            setIsLoading(false);
        };
        /* eslint-enable */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "w-full relative",
            style: {
                paddingBottom: "".concat(100 / aspectRatio, "%")
            },
            children: [
                isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-gray-200",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: src,
                    alt: alt,
                    layout: "fill",
                    objectFit: "contain",
                    className: "my-4",
                    onLoadingComplete: handleImageLoad,
                    placeholder: "blur",
                    blurDataURL: blurDataURL,
                    priority: true
                })
            ]
        });
    }
};
// const CustomCodeHighlighter = ({ children, language, inline, ...props }: SyntaxHighlighterProps & { inline?: boolean }) => {
// 	const { resolvedTheme } = useTheme();
// 	const [currentTheme, setCurrentTheme] = useState<any>(atomOneDark);
// 	useEffect(
// 		() => resolvedTheme === 'light' ? setCurrentTheme(atomOneLight) : setCurrentTheme(atomOneDark),
// 		[resolvedTheme]
// 	);
// 	return !inline ? (
// 		<SyntaxHighlighter
// 			style={currentTheme}
// 			language={language}
// 			PreTag="div"
// 			customStyle={{
// 				padding: undefined
// 			}}
// 			className="text-md rounded-xl px-4 py-4 border border-grey-300 dark:border-grey-700 shadow-md shadow-grey-500 dark:shadow-grey-800"
// 			{...props}
// 		>
// 			{String(children).replace(/\n$/, '')}
// 		</SyntaxHighlighter>
// 	) : (
// 		<code className={`bg-indigo-100 dark:bg-slate-800 p-1 rounded-md`} {...props}>
// 			{children}
// 		</code>
// 	)
// };
var CustomCodeHighlighter = function(_param) {
    var children = _param.children, language = _param.language, inline = _param.inline, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "children",
        "language",
        "inline"
    ]);
    var resolvedTheme = (0,next_themes__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .F)().resolvedTheme;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_8__/* .atomOneDark */ .FE), currentTheme = ref[0], setCurrentTheme = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), copied = ref1[0], setCopied = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        resolvedTheme === "light" ? setCurrentTheme(react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_8__/* .atomOneLight */ .lf) : setCurrentTheme(react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_8__/* .atomOneDark */ .FE);
    }, [
        resolvedTheme
    ]);
    // Function to handle code copy
    var handleCopy = function() {
        navigator.clipboard.writeText(String(children).replace(/\n$/, ""));
        setCopied(true);
        setTimeout(function() {
            return setCopied(false);
        }, 2000); // Reset after 2 seconds
    };
    return !inline ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                onClick: handleCopy,
                className: "absolute right-4 top-4 text-sm p-1 rounded-md bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700",
                children: copied ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_9__/* .FiCheck */ .UgA, {
                    className: "text-green-500"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_9__/* .FiCopy */ .C3L, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                style: currentTheme,
                language: language,
                PreTag: "div",
                customStyle: {
                    padding: undefined
                },
                className: "text-md rounded-xl px-4 py-4 border border-grey-300 dark:border-grey-700 shadow-md shadow-grey-500 dark:shadow-grey-800"
            }, props), {
                children: String(children).replace(/\n$/, "")
            }))
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("code", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: "bg-indigo-100 dark:bg-slate-800 p-1 rounded-md"
    }, props), {
        children: children
    }));
};
var toBase64 = function(str) {
    return  false ? 0 : window.btoa(str);
};
var shimmer = function() {
    var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 600;
    return '\n<svg width="'.concat(w, '" height="').concat(h, '" xmlns="http://www.w3.org/2000/svg" version="1.1">\n  <defs>\n    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">\n      <stop offset="0%" style="stop-color:#945bf1;stop-opacity:1" />\n      <stop offset="0%" style="stop-color:#bb48bf;stop-opacity:1" >\n        <animate \n          attributeName="offset" \n          from="0%"\n          to="100%"\n          dur="1s"\n          repeatCount="indefinite"/>\n      </stop>\n      <stop offset="100%" style="stop-color:#945bf1;stop-opacity:1" />\n    </linearGradient>\n  </defs>\n  <rect width="').concat(w, '" height="').concat(h, '" fill="url(#grad1)" />\n</svg>\n');
};
var blurDataURL = "data:image/svg+xml;base64,".concat(toBase64(shimmer()));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9927,6809,9774,2888,179], function() { return __webpack_exec__(65529); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);